import { Canvas } from "@react-three/fiber";
import React, {
  createContext,
  createRef,
  useEffect,
  useRef,
  useState,
} from "react";
import "./App.css";
import IntroScreen from "./IntroScreen";
import KeyboardManager from "./KeyboardManager";
import ThreeManager from "./ThreeManager";
import SettingsMenu from "./SettingsMenu";

export const AppContext = createContext<any>({});

function App() {
  const [hasStarted, setHasStarted] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [highGraphics, setHighGraphics] = useState(false);
  const masterVolumeRef = useRef(1);
  const wallOpacityRef = useRef(1);

  const amtOfLoadedSounds = useRef(0);
  const amtOfSounds = 8;

  const playerSpeed = useRef({ x: 0, z: 0 });
  const playerRef = useRef<any>();
  const cameraRef = useRef<any>();

  const keysRef = useRef({
    ArrowRight: false,
    ArrowLeft: false,
    ArrowUp: false,
    ArrowDown: false,
  });

  const soundHasLoaded = () => {
    amtOfLoadedSounds.current++;
    if (amtOfLoadedSounds.current === amtOfSounds) {
      setHasLoaded(true);
    }
  };

  useEffect(() => {
    if (typeof window !== "undefined") {
      if (window.innerWidth > 800) {
        setHighGraphics(true);
      }
    }
  }, []);

  return (
    <div className="App">
      <AppContext.Provider
        value={{
          keysRef: keysRef,
          worldSize: { x: 83, z: 83 },
          startPosition: { x: -36, z: 36 },
          wallThickness: 0.2,
          playerRef: playerRef,
          cameraRef: cameraRef,
          playerSpeed: playerSpeed,
          playerSize: 2,
          hasStarted: hasStarted,
          hasLoaded: hasLoaded,
          soundHasLoaded: soundHasLoaded,
          setHasStarted: setHasStarted,
          highGraphics: highGraphics,
          setHighGraphics: setHighGraphics,
          masterVolumeRef: masterVolumeRef,
          wallOpacityRef: wallOpacityRef,
        }}
      >
        <ThreeManager />
        <KeyboardManager />
        <IntroScreen />
        <SettingsMenu />
      </AppContext.Provider>
    </div>
  );
}

export default App;
